import script from "./result-field.vue?vue&type=script&setup=true&lang=ts"
export * from "./result-field.vue?vue&type=script&setup=true&lang=ts"

import "./result-field.vue?vue&type=style&index=0&id=3340ac90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3340ac90"]])

export default __exports__